<template>
    <div class="row pricing-table-two">
        <div class="col-md-6 col-lg-4 pricing-table pricing-table--popular wow move-up" v-for="(pricing, index) in pricingTable" :key="index">
            <div class="pricing-table__inner">
                <div class="pricing-table__feature-mark" v-if="pricing.isPopular">
                    <span>Popular Choice</span>
                </div>
                <div class="pricing-table__header">
                    <div class="pricing-table__image">
                        <img :src="pricing.thumb" class="img-fluid" :alt="pricing.alt">
                    </div>
                    <h5 class="pricing-table__title">{{ pricing.title }}</h5>
                    <div class="pricing-table__price-wrap d-block year-price">
                        <span>Yearly Plan</span>
                        <div class="d-flex justify-center">
                            <h6 class="price">{{ pricing.yearValue }}</h6>
                            <h6>/ month</h6>
                        </div>
                    </div>
                    <hr />
                    <div class="pricing-table__price-wrap d-block month-price">
                        <span>Monthly Plan</span>
                        <div class="d-flex justify-center">
                            <h6 class="mr-1">{{ pricing.monthValue }}</h6>
                            <h6>/ month</h6>
                        </div>
                    </div>
                </div>
                <div class="pricing-table__body">
                    <div class="pricing-table__footer">
                        <button class="ht-btn ht-btn-default" :class="{'btn--green': pricing.active}" @click="$router.push({path: '/login'})">Get started</button>
                    </div>
                    <ul class="pricing-table__list text-left">
                        <li v-for="(list, index) in pricing.price" :key="index">{{ list }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'pricingTwo',
        data(){
            return {
                pricingTable: [
                    {
                        thumb: require('@/assets/static-img/pricing/package-01.png'),
                        title: 'Lite',
                        yearValue: 'RM32',
                        monthValue: 'RM55',
                        alt: 'Pricing Thumb',
                        isPopular: false,
                        active: false,
                        price: ['3 forms', '1-5 users', 'QuickPay RM2 or 3% whichever higher', 'Unlimited products upload', 'Reporting - Business performance', 'Customer Database - Listing only', 'Coupon code system', 'Inventory management']
                    },
                    {
                        thumb: require('@/assets/static-img/pricing/package-02.png'),
                        title: 'Standard',
                        yearValue: 'RM68',
                        monthValue: 'RM90',
                        alt: 'Pricing Thumb',
                        isPopular: true,
                        active: true,
                        price: ['8 forms', '1-12 users', 'QuickPay RM2 or 2% whichever higher', 'Unlimited products upload', 'Reporting - Business performance, Sales performance and ranking', 'Customer Database - Listing + Order history', 'Customisable URL with own brand', 'Own brand tracking page, Eg. galado.quicksend/track/YDHFE', 'Coupon code system', 'Inventory management']
                    },
                    {
                        thumb: require('@/assets/static-img/pricing/package-03.png'),
                        title: 'Business',
                        yearValue: 'RM129',
                        monthValue: 'RM199',
                        alt: 'Pricing Thumb',
                        isPopular: false,
                        active: false,
                        price: ['20 forms', '1-20 users', 'QuickPay RM2 or 2% whichever higher', 'Unlimited products upload', 'Reporting - Business performance, Sales performance and ranking', 'Customer Database - Listing + Order history', 'Customisable URL with own brand', 'Own brand tracking page, Eg. galado.quicksend/track/YDHFE', 'Coupon code system', 'Inventory management']
                    // },
                    // {
                    //     thumb: require('@/assets/static-img/pricing/aeroland-pricing-image-07.png'),
                    //     title: 'Enterprise',
                    //     value: 'Let\'s talk',
                    //     alt: 'Pricing Thumb',
                    //     isPopular: false,
                    //     active: false,
                    //     price: ['Everything in Business', 'More forms', 'More users']
                    }
                ]
            }
        }
    }
</script>

<style>
.pricing-table-two .pricing-table__price-wrap.month-price .price {
    font-size: 32px;
}
</style>

<!-- <template>
    <div class="row pricing-table-two">
        <div class="col-md-6 col-lg-4 pricing-table pricing-table--popular wow move-up" v-for="(pricing, index) in pricingTable" :key="index">
            <div class="pricing-table__inner">
                <div class="pricing-table__feature-mark" v-if="pricing.isPopular">
                    <span>Popular Choice</span>
                </div>
                <div class="pricing-table__header">
                    <div class="pricing-table__image">
                        <img :src="pricing.thumb" class="img-fluid" :alt="pricing.alt">
                    </div>
                    <h5 class="pricing-table__title">{{ pricing.title }}</h5>
                    <div class="pricing-table__price-wrap">
                        <h6 class="price">RM{{ pricing.value }}</h6>
                    </div>
                </div>
                <div class="pricing-table__body">
                    <div class="pricing-table__footer">
                        <button class="ht-btn ht-btn-default" :class="{'btn--green': pricing.active}">Get started</button>
                    </div>
                    <ul class="pricing-table__list text-left">
                        <li v-for="(list, index) in pricing.price" :key="index">{{ list }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'pricingTwo',
        data(){
            return {
                pricingTable: [
                    {
                        thumb: require('@/assets/static-img/pricing/aeroland-pricing-image-06.png'),
                        title: 'Personal',
                        value: '20',
                        alt: 'Pricing Thumb',
                        isPopular: false,
                        active: false,
                        price: ['3 forms', '1-5 users', 'QuickPay RM2 or 3% whichever higher', 'Unlimited products upload', 'Reporting - Business performance', 'Customer Database - Listing only', 'Coupon code system', 'Inventory management']
                    },
                    {
                        thumb: require('@/assets/static-img/pricing/aeroland-pricing-image-05.png'),
                        title: 'Business',
                        value: '39',
                        alt: 'Pricing Thumb',
                        isPopular: true,
                        active: true,
                        price: ['8 forms', '1-12 users', 'QuickPay RM2 or 2% whichever higher', 'Unlimited products upload', 'Reporting - Business performance, Sales performance and ranking', 'Customer Database - Listing + Order history', 'Customisable URL with own brand', 'Own brand tracking page, Eg. galado.quicksend/track/YDHFE', 'Coupon code system', 'Inventory management']
                    },
                    {
                        thumb: require('@/assets/static-img/pricing/aeroland-pricing-image-07.png'),
                        title: 'Enterprise',
                        value: 'Let\'s talk',
                        alt: 'Pricing Thumb',
                        isPopular: false,
                        active: false,
                        price: ['Everything in Business', 'More forms', 'More users']
                    }
                ]
            }
        }
    }
</script> -->